import React, { Component } from 'react';

import AttendanceHome from './attendance/AttendanceHome';
import AttendanceAll from './attendance/AttendanceAll';
import AttendanceTeam from './attendance/AttendanceTeam';
import AttendanceReport from './attendance/AttendanceReport';

class Attendance extends Component {
  constructor(props) {
      super(props);
      this.state = {
        curPage: 1
      };
      this.handlePageChange = this.handlePageChange.bind(this);
  }
  handlePageChange(event) {
    /*let num;
    if(event.currentTarget.id === "attendanceHome"){
      num = 1;
    } else if (event.currentTarget.id === "attendanceAll"){
      num = 2;
    } else if (event.currentTarget.id === "attendanceTeam"){
      num = 3;
    } else if (event.currentTarget.id === "attendanceReport"){
      num = 4;
    }
    this.setState({
      curPage : num
    });*/
  }
  getCurPage() {
    if(this.state.curPage === 1){
      return <AttendanceHome />;
    } else if (this.state.curPage === 2) {
      return <AttendanceAll />;
    } else if (this.state.curPage === 3) {
      return <AttendanceTeam />;
    } else if (this.state.curPage === 4) {
      return <AttendanceReport />;
    }
  }
  render() {
    return (
      <div>
        <div className="row">
          <div className="small-12 columns">
            <div className="button-container">
              <button id="attendanceHome" className={"button medium" + (this.state.curPage === 1 ? '' : ' secondary')} onClick={this.handlePageChange}>Home Attendance</button>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="small-12 columns">
            {this.getCurPage()}
          </div>
        </div>
      </div>
    );
  }
}

export default Attendance;



// WEBPACK FOOTER //
// ./src/components/Attendance.js